import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Camera, Sparkles, Share2 } from "lucide-react";

interface HeroPhotoToContentProps {
  onUploadClick: () => void;
  /** Hotel-Edition: hotels do not know the team personas (Mike 2026-10-09, Befund 14). */
  hotel?: boolean;
}

/** Step 2 text: agencies meet Emma & Max, hotels read "Ihr Team". Platforms stay all three for both (Mike
 *  2026-10-09: photo posts go to LinkedIn, Facebook and Instagram). */
export function photoHeroTeamText(hotel: boolean): string {
  return hotel ? "Ihr Team erstellt passende Beiträge für jede Plattform" : "Emma & Max erstellen perfekte Posts für jede Plattform";
}

export function HeroPhotoToContent({ onUploadClick, hotel = false }: HeroPhotoToContentProps) {

  const steps = [
    {
      number: 1,
      icon: Camera,
      title: "Foto hochladen",
      description: "Laden Sie ein Bild aus Ihrem Unternehmensalltag hoch"
    },
    {
      number: 2,
      icon: Sparkles,
      title: "KI analysiert",
      description: photoHeroTeamText(hotel)
    },
    {
      number: 3,
      icon: Share2,
      title: "Automatisch posten",
      description: "Ihre Beiträge erscheinen auf LinkedIn, Facebook und Instagram"
    }
  ];

  return (
    <Card 
      className="border-2 border-primary"
      data-testid="card-hero-photo-to-content"
    >
      <CardContent className="pt-6 pb-6 sm:pt-8 sm:pb-8">
        <div className="flex items-start sm:items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
          <Camera className="w-6 h-6 sm:w-8 sm:h-8 text-primary flex-shrink-0" />
          <h2 className="text-xl sm:text-2xl font-semibold">
            Vom Foto zum perfekten Social Media Post
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-3 mb-6">
          {steps.map((step) => (
            <div key={step.number} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center font-bold flex-shrink-0">
                {step.number}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <step.icon className="w-4 h-4 text-primary" />
                  <h4 className="font-medium">{step.title}</h4>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed break-words">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3">
          <Button 
            onClick={onUploadClick}
            size="lg"
            className="min-h-[44px]"
            data-testid="button-upload-photo"
          >
            <Camera className="w-4 h-4 mr-2" />
            Jetzt Foto hochladen
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
